import { _post } from "../Api";
import { toast } from "react-toastify";
import { setSpMerchant } from "./CloudActions";

export function updateSpMerchant(spMerchant, newData, oldValues) {
  return updateSpMerchants([spMerchant], [newData], [oldValues]).then((spMerchants) => {
    return Promise.resolve(spMerchants[0]);
  });
}

export function updateSpMerchants(spMerchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in spMerchants) {
    if (spMerchants[i]) {
      data.push({
        spMerchantId: spMerchants[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        ...newData[i],
      });
    }
  }
  return _post("/nova/v2/sp_merchants/update", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      res.data.map((spMerchant) => {
        setSpMerchant(spMerchant);
      });

      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}
